import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';

export const analytics = Analytics({
    app: 'pxn_patient_app',
    plugins: [
        googleTagManager({
            containerId: process.env.REACT_APP_GTM_TRACKING_ID
        })
    ]
});